<template>
    <div class="flex items-center py-1">
        <div class="col-span-6 sm:col-span-5 w-full bg-white" v-if="config.type === 'datepicker'">
        <jet-label class="block text-base" :value="config.text" />
            <datepicker
                :language="ptBR"
                placeholder="Selecione a data"
                :format="'dd/MM/yyyy'"
                :clear-button="true"
                clear-button-icon="fa fa-times text-gray-500 text-right"
                class="relative w-full form-input border border-solid border-black rounded-md text-xs pb-3 pt-2 px-3"
                v-model="selectedDate"
                @input="$emit('input', moment(selectedDate) || null)"
                name="operation_date">
            </datepicker>
        </div>
        <div class="col-span-6 sm:col-span-5 w-full" v-if="config.type === 'dropdown'">
        <jet-label class="block text-base" :value="config.text" />
            <v-select label="name"
                      class="w-full py-1"
                      placeholder="Selecione uma das opções"
                      :options="config.options"
                      v-model="selectedOption"
                      @input="$emit('input', selectedOption ? selectedOption.id: null)">
                <template slot="no-options">
                    <div class="py-4 mt-1">
                        Procurar...
                    </div>
                </template>
                <template slot="option" slot-scope="option">
                    <div class="d-center">
                        {{ option.name }}
                    </div>
                </template>
                <template slot="selected-option" slot-scope="option">
                    <div class="selected d-center">
                        {{ option.name }}
                    </div>
                </template>
            </v-select>
        </div>
        <div class="w-full bg-white" v-if="config.type === 'date_interval'">
            <jet-label
                class="text-base whitespace-nowrap col-span-6 block"
                :value="config.text"
            />
            <div class="items-center w-full grid grid-cols-12 gap-2 text-gray-700">
                <jet-label
                    class="text-xs whitespace-nowrap col-span-6"
                    value="Data inicial"
                />
                <jet-label
                    class="text-xs whitespace-nowrap col-span-6"
                    value="Data final"
                />

                <div class="flex col-span-6 w-full rounded-md border border-black pb-3 pt-2.5 px-3">
                    <div class="col-span-2  w-full">
                        <div class="w-full grid grid-cols-3">
                            <div class="col-span-2 ">
                                <input
                                    id="date_start"
                                    type="text"
                                    placeholder="Selecione a data"
                                    onfocus="this.type='date'"
                                    clear-button-icon="fa fa-times text-gray-500 text-right"
                                    class="focus:outline-none w-full border-black text-gray-500 "
                                    v-model="dateFrom"
                                    @input="dateStartChanged"
                                />
                            </div>
                            <div class="col-span-1 ">
                                <input
                                    id="time_start"
                                    type="time"
                                    placeholder="hh:mm:ss"
                                    onfocus="this.type='time'"
                                    v-model="timeIntervalFrom"
                                    @input="dateStartChanged"
                                    class="focus:outline-none w-full border-black text-gray-500 "
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex col-span-6 w-full rounded-md border border-black pb-3 pt-2.5 px-3">
                    <div class="col-span-2 w-full">
                        <div class="w-full grid grid-cols-3">
                            <div class="col-span-2 ">
                                <input
                                    id="date_end"
                                    type="text"
                                    placeholder="Selecione a data"
                                    onfocus="this.type='date'"
                                    class=" focus:outline-none w-full border-black text-gray-500 "
                                    v-model="dateTo"
                                    @input="dateEndChanged"
                                />
                            </div>
                            <div class="col-span-1 ">
                                <input
                                    id="time_end"
                                    type="time"
                                    placeholder="hh:mm:ss"
                                    onfocus="this.type='time'"
                                    value=""
                                    v-model="timeIntervalTo"
                                    @input="dateEndChanged"
                                    class="focus:outline-none w-full border-black text-gray-500 "
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="flex w-full mb-3" v-if="config.type === 'date_interval2'">
            <filter-date-interval
                :selected-date-range="selectedDateRange"
                :config="config"
                @input="$emit('input', $event)"
            />
        </div>

        <div class="w-full bg-white" v-if="config.type === 'text'">
            <jet-label
                class="text-base whitespace-nowrap col-span-6 block"
                :value="config.text"
            />
            <div>
                <jet-input v-if="!config.mask"
                    class="w-full"
                    :placeholder="config.text"
                    v-model="fieldValue"
                    @input="$emit('input', fieldValue || null)"
                />
                <jet-masked-input
                    v-else
                    id="billing_info_phone_number"
                    :mask="config.mask"
                    class="w-full"
                    v-bind:placeholder="config.text"
                    v-model="fieldValue"
                    @input="$emit('input', fieldValue || null)"
                    type="text"
                />
            </div>
        </div>
        <div class="flex w-full mb-3"  v-if="config.type === 'autocomplete'">
            <filter-auto-complete v-model="selectedItemAutoComplete" :config="config" @input="$emit('input', selectedItemAutoComplete.id)"/>
        </div>
        <div class="flex w-full mb-3"  v-if="config.type === 'checkbox_icon'">
            <filter-checkbox-icon v-model="checkBoxIcon" :config="config" @input="$emit('input', checkBoxIcon)"/>
        </div>
        <div class="flex w-full" v-if="config.type === 'number_interval'">
            <filter-number-interval
                :config="config"
                :selected-number-money-range="selectedNumberMoneyRange"
                :selected-number-range="selectedNumberRange"
                @input="$emit('input', $event)"
            />
        </div>
    </div>
</template>

<script>
import FilterAutoComplete from "./FilterAutoComplete";
import JetAutoComplete from "../../Jetstream/AutoComplete";
import JetDatePicker from "../../Jetstream/DatePicker";
import JetMaskedInput from "../../Jetstream/MaskedInput";
import JetInput from "../../Jetstream/Input";
import ptBR from 'vuejs-datepicker/dist/locale/translations/pt-BR.js';
import moment from 'moment/dist/moment';
import JetLabel from "../../Jetstream/Label";
import eventBus from "/resources/js/Layouts/eventBus.vue";
import FilterCheckboxIcon from './FilterCheckboxIcon.vue';
import FilterNumberInterval from './FilterNumberInterval.vue';
import FilterDateInterval from './FilterDateInterval.vue';

export default {
    components: {
        JetLabel,
        FilterAutoComplete,
        JetAutoComplete,
        JetDatePicker,
        JetMaskedInput,
        JetInput,
        FilterCheckboxIcon,
        FilterNumberInterval,
        FilterDateInterval,
    },
    props: {
        value: [String, Object, Boolean, Number, Array],
        maxWidth: {
            type: Number,
            default: 500
        },
        config: Object
    },
    data() {
        return {
            dateIntervalFrom: null,
            dateIntervalTo: null,
            dateFrom: null,
            dateTo: null,
            checkBoxIcon: null,
            timeIntervalFrom: '00:00:00',
            timeIntervalTo: '23:59:59',
            selectedDate: this.value,
            selectedDateRange: {
                'from': this.value && this.value.from ? this.value.from : null,
                'to': this.value && this.value.to ? this.value.to : null
            },
            selectedNumberMoneyRange: {
                from: {
                    decimal: ",",
                    thousands: ".",
                    precision: 2,
                    masked: false
                },
                to: {
                    decimal: ",",
                    thousands: ".",
                    precision: 2,
                    masked: false
                }
            },
            selectedNumberRange: {
                from: this.value?.number_from,
                to: this.value?.number_to
            },
            selectedOption: this.value && this.config.options ? this.config.options.find(item => this.value === item.id) : this.value,
            fieldValue: this.value,
            ptBR: ptBR,
        }
    },
    methods: {
        returnDateFormat(dateString) {
            try {
                if (dateString === null) {
                    return null;
                }

                const date_ = dateString.split('T')[0]
                const time_ = dateString.split('T')[1]

                const dateParts = date_.split('-')
                const timeParts = time_.split(':')
                return new Date(
                    Number(dateParts[0]), Number(dateParts[1]) - 1,
                    Number(dateParts[2]),
                    Number(timeParts[0]),
                    Number(timeParts[1]),
                    Number(timeParts[2]));
            } catch (e) {
                return null
            }
        },
        forceDataChanged() {
            try {
                if (this.dateIntervalFrom !== null && this.dateIntervalTo !== null) {
                    if (this.dateIntervalTo < this.dateIntervalFrom) {
                        this.dateIntervalFrom = null
                        this.dateIntervalTo = null
                        this.dateFrom = null
                        this.dateTo = null
                        this.$toast.open({
                            message: 'Data inicial não pode ser maior que a data final.',
                            type: 'error',
                            duration: 3000,
                            position: 'top-right',
                            showCloseButtonOnHover: true
                        });
                        return false
                    }
                }

                this.selectedDateRange = {
                    'from': this.dateIntervalFrom ? moment(this.dateIntervalFrom).format("YYYY-MM-DD HH:mm:ss") : null,
                    'to': this.dateIntervalTo ? moment(this.dateIntervalTo).format("YYYY-MM-DD HH:mm:ss") : null
                };
                this.$emit('input', this.selectedDateRange || null);
            } catch (e) {

            }
        },
        dateStartChanged: _.debounce(function () {
            try {
                const value = this.dateFrom != null ? `${this.dateFrom}T${this.timeIntervalFrom !== null ? this.timeIntervalFrom : '00:00'}:00` : null;
                this.dateIntervalFrom = this.returnDateFormat(value)
                this.forceDataChanged()
            } catch (e) {
            }
        }, 700),
        dateEndChanged: _.debounce(function () {
            try {
                const value = this.dateTo != null ? `${this.dateTo}T${this.timeIntervalTo !== null ? this.timeIntervalTo : '23:59'}:59` : null;
                this.dateIntervalTo = this.returnDateFormat(value)
                this.forceDataChanged()
            } catch (e) {
            }
        }, 700),
        focus() {
            this.$refs.input.focus()
        },
        moment(data) {
            return data ? moment.utc(data).format('yyyy-MM-DD\T00:00:00') : null;
        }
    },
    mounted(){
        if(this.config.type === 'date_interval'){

            if(this.value && this.value.from){
                this.dateFrom = this.value.from
                this.dateFrom = moment(this.value.from).format("YYYY-MM-DD");
                this.timeIntervalFrom = moment(this.value.from).format("HH:mm:ss");

                document.getElementById('date_start').setAttribute('type', 'date');
                document.getElementById('time_start').setAttribute('type', 'time');
            }

            if(this.value && this.value.to){
                this.dateTo = this.value.to
                this.dateTo = moment(this.value.to).format("YYYY-MM-DD");
                this.timeIntervalTo = moment(this.value.to).format("HH:mm:ss");

                document.getElementById('date_end').setAttribute('type', 'date');
                document.getElementById('time_end').setAttribute('type', 'time');
            }
            this.dateStartChanged();
            this.dateEndChanged();
        }
    },
    created() {
        eventBus.$on("clearFilter", (p) => {
            if (this.config.key === p.key) {
                switch (this.config.type) {
                    case 'datepicker':
                        this.selectedDate = null;
                        break;
                    case 'dropdown':
                        this.selectedOption = null;
                        break;
                    case 'autocomplete':
                        this.selectedItemAutoComplete = null;
                        break;
                    case 'checkBoxIcon':
                        this.checkBoxIcon = null;
                        break;
                }
                this.$emit('input', null);
            }
        });
    }
}
</script>
